import { openSplitViewState } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { contentSplitViewState } from 'shared/states';

const useShowDropArea = () => {
    const contentSplitView = useAtomValue(contentSplitViewState);
    const openSplitView = useAtomValue(openSplitViewState);

    return !openSplitView || 'attachmentId' in contentSplitView;
};

export default useShowDropArea;
